var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.60852 5.76956C2.60852 5.07299 3.17321 4.5083 3.86978 4.5083H16.1241C16.8206 4.5083 17.3853 5.07299 17.3853 5.76956V15.876C17.3853 16.5726 16.8206 17.1373 16.1241 17.1373H3.86978C3.17321 17.1373 2.60852 16.5726 2.60852 15.876V5.76956ZM3.86978 5.58938C3.77027 5.58938 3.6896 5.67005 3.6896 5.76956V15.876C3.6896 15.9755 3.77027 16.0562 3.86978 16.0562H16.1241C16.2236 16.0562 16.3042 15.9755 16.3042 15.876V5.76956C16.3042 5.67005 16.2236 5.58938 16.1241 5.58938H3.86978Z",
  fill: "#9498A0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5696 6.90991H15.3534V10.6937H11.5696V6.90991ZM12.6507 7.99099V9.61261H14.2723V7.99099H12.6507Z",
  fill: "#9498A0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.489 12.5127H5.39111V11.4316H10.489V12.5127Z",
  fill: "#9498A0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.4674 14.8252H5.39111V13.7441H10.4674V14.8252Z",
  fill: "#9498A0"
});

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.f111fa60.svg";
export { ForwardRef as ReactComponent };